export function calcThanhTien(donGia: number, soLuong: number) {
  return Math.round(donGia * soLuong);
}

export function calcThanhTienTotal(
  lines: { don_gia: number; so_luong_lay: number }[]
) {
  return lines.reduce(
    (total, line) => total + calcThanhTien(line.don_gia, line.so_luong_lay),
    0
  );
}
